import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import classNames from "classnames";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { IDS } from "../../../../utils/IDS";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import {
  Create,
  GetAllEcoFriendly,
  GetSingle,
  Update,
} from "../../../../features/admin/master/ecofriendly/Slice";
import { getAllVehicleCategory } from "../../../../features/admin/common/Slice";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const vehicleCategoryList = useSelector(
    (state) => state.common.all_vehicle_category,
  );

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setError,
    setValue,
    control,
    formState: { errors },
    reset,
  } = useForm();

  const imageFile = watch("image");
  const selectedType = watch("type") || "";

  const [editData, setEditData] = React.useState(null);

  const GetData = async (editId) => {
    try {
      reset({ name: "", type: "", vehicle_category_id: [] });
      const res = await dispatch(GetSingle(editId));
      if (res.meta.requestStatus === "fulfilled") {
        const responseData = res?.payload?.data?.data;
        reset(responseData);
        if (responseData?.type) {
          await dispatch(getAllVehicleCategory(responseData.type));
        }
        setEditData(responseData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id) GetData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Set vehicle_category_id when vehicleCategoryList is loaded and we have edit data
  useEffect(() => {
    if (
      editData &&
      vehicleCategoryList.length > 0 &&
      editData.vehicle_category_id
    ) {
      let vehicleCategoryIds = [];

      // Handle different formats: array, JSON string, or single value
      if (typeof editData.vehicle_category_id === "string") {
        try {
          vehicleCategoryIds = JSON.parse(editData.vehicle_category_id);
        } catch {
          vehicleCategoryIds = [editData.vehicle_category_id];
        }
      } else if (Array.isArray(editData.vehicle_category_id)) {
        vehicleCategoryIds = editData.vehicle_category_id;
      } else {
        vehicleCategoryIds = [editData.vehicle_category_id];
      }

      // Extract IDs if they're objects
      const ids = vehicleCategoryIds.map((id) =>
        typeof id === "object" && id !== null
          ? id.value || id.vehicle_category_id || id.id
          : id,
      );

      const selectedCategories = vehicleCategoryList.filter((cat) =>
        ids.includes(cat.value),
      );
      if (selectedCategories.length > 0) {
        setValue("vehicle_category_id", selectedCategories);
      }
      setEditData(null); // Clear edit data after setting
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleCategoryList, editData]);

  // Fetch vehicle categories when type changes
  useEffect(() => {
    if (selectedType) {
      dispatch(getAllVehicleCategory(selectedType));
      // Clear vehicle_category_id when type changes
      setValue("vehicle_category_id", []);
      setEditData(null);
    }
  }, [selectedType]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("type", data?.type);

      // Handle vehicle_category_id for multiple select
      if (
        data?.vehicle_category_id &&
        Array.isArray(data.vehicle_category_id) &&
        data.vehicle_category_id.length > 0
      ) {
        // Extract IDs from select options (which are objects with value and label)
        const vehicleCategoryIds = data.vehicle_category_id.map(
          (cat) => cat.value,
        );
        sendData.append(
          "vehicle_category_id",
          JSON.stringify(vehicleCategoryIds),
        );
      }

      const imageValue = data?.image;
      if (
        imageValue &&
        typeof imageValue !== "string" &&
        imageValue.length > 0
      ) {
        sendData.append("image", imageValue[0]);
      }

      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }

      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAllEcoFriendly());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({
          name: "",
          type: "",
          vehicle_category_id: [],
          image: "",
        });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }

      if (response.payload === 406) {
        await setError("name", {
          type: "manual",
          message: "Eco Friendly already exists",
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add ecofriendly", error);
    }
  };

  const typeOptions = [
    { value: "Transport", label: "Transport" },
    { value: "Cab", label: "Cab" },
    { value: "Share", label: "Share" },
  ];

  return (
    <>
      <Add_section_title
        title={id ? "Edit Eco Friendly" : "Add Eco Friendly"}
        alltotal=""
      />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  {...register("name", {
                    required: "Name is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.name && (
                  <span className="text-danger">{errors.name?.message}</span>
                )}
              </div>
            </div>

            <div className="form-group">
              <Form.Label>Type</Form.Label>

              <Controller
                name="type"
                control={control}
                rules={{
                  required: "Type is required",
                }}
                render={({ field }) => (
                  <Select
                    options={typeOptions}
                    placeholder="Select Type"
                    value={
                      typeOptions.find(
                        (option) => option.value === field.value,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      field.onChange(selectedOption?.value || "")
                    }
                    isClearable
                    classNamePrefix="react-select"
                  />
                )}
              />

              {errors.type && (
                <span className="text-danger">{errors.type.message}</span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Vehicle Category</Form.Label>
                <Controller
                  name="vehicle_category_id"
                  control={control}
                  rules={{ required: "Vehicle Category is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isMulti
                      options={vehicleCategoryList}
                      value={field.value || []}
                      onChange={(selected) => {
                        field.onChange(selected || []);
                      }}
                      isDisabled={!selectedType}
                      placeholder={
                        selectedType
                          ? "Select Vehicle Category"
                          : "Select Type first"
                      }
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.vehicle_category_id
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                      }}
                    />
                  )}
                />
                {errors.vehicle_category_id && (
                  <span className="text-danger">
                    {errors.vehicle_category_id.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="ecoFriendlyImage"
              >
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    required:
                      typeof getValues("image") === "string"
                        ? false
                        : "Image is required",
                  })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </Form.Group>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("image") === "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>

            <div className="form_submit_div">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        reset({ name: "", type: "", vehicle_category_id: [] });
                        setId("");
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
